import { theme } from 'antd'

const geistStack = '"Geist", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'

export const lightTheme = {
  algorithm: theme.defaultAlgorithm,
  token: {
    fontFamily: geistStack,
    colorPrimary: '#2563eb',
    colorBgBase: '#ffffff',
    colorTextBase: '#0f172a',
    colorBorder: '#e2e8f0',
    borderRadius: 6,
    breadCrumbColor: '#1677ff',
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      bodyBg: '#fafdff',
    },
    Button: {
      primaryColor: '#ffffff',
      colorPrimary: '#1976d2',
      colorPrimaryHover: '#1368bd',
    },
    Menu: {
      itemColor: '#0f172a',
      itemSelectedColor: '#1976d2',
      itemSelectedBg: '#e0e7ff',
    },
  },
}

export const darkTheme = {
  algorithm: theme.darkAlgorithm,
  token: {
    fontFamily: geistStack,
    colorPrimary: '#60a5fa',
    colorBgBase: '#161617',
    // colorTextBase: '#e5e7eb',
    // colorBorder: '#334155',
    borderRadius: 6,
  },
  components: {
    Layout: {
      headerBg: '#29292d',
      bodyBg: '#161617',
    },
    Button: {
      primaryColor: '#ffffff',
      colorPrimary: '#1976d2',
      colorPrimaryHover: '#1368bd',
    },
    Menu: {
      itemColor: '#e5e7eb',
      itemSelectedColor: '#60a5fa',
      itemSelectedBg: '#1e293b',
    },
  },
}
